import { PageHead } from "@generalapplications/html-render/react";
import { useParams } from "react-router-dom";

import { ServiceTemplate } from "@/app/pages/serviceDetail/components/ServiceTemplate";
import { getServiceBySlug, isPreviewableService } from "@/content/services";
import { routes } from "@/app/common/functions/routes/routes";
import { pageHead, sectionTrail } from "@/app/common/functions/seo/pageHead";

import { NotFoundPage } from "@/app/pages/notFound/NotFoundPage";

export function ServiceDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const found = slug ? getServiceBySlug(slug) : undefined;
  // A draft service resolves in dev and 404s in production, so an unpublished
  // page can be reviewed locally without ever being reachable on prod.
  const service = found && isPreviewableService(found) ? found : undefined;

  if (!service) {
    return <NotFoundPage />;
  }

  const path = routes.services.detail(service.slug);
  return (
    <>
      <PageHead
        head={pageHead({
          path,
          title: service.seoTitle,
          description: service.seoDescription,
          breadcrumbs: sectionTrail(
            { name: "Services", path: routes.services.index },
            { name: service.title, path },
          ),
        })}
      />
      <ServiceTemplate service={service} />
    </>
  );
}
